import { defineStore } from 'pinia';
import { ref } from 'vue';
export const useCalendarImagesStore = defineStore('calendarImages', () => {
    // La sintaxis dice que el tipo del ref es un array de CalendarImage y el valor del ref un array vacio
    const calendarImages = ref([]);
    const imageSelected = ref(false);
    return { calendarImages, imageSelected };
});
